/**
 * Определение тенанта из поддомена текущего хоста.
 *
 * `<tenant>.omniflow.ru` → tenant `<tenant>` (= core.tenants.id, lowercase-слаг).
 * Голый домен / IP / localhost / служебный поддомен → null: тенант неизвестен,
 * форма логина показывает ручное поле ввода (dev / прямой админ-доступ).
 *
 * Это запасной путь: сначала страница входа спрашивает сервер о своих веб-доменах тенанта
 * (`resolveHostTenant` в `entities/auth`, эпик CUSTDOM) — `callc.cardio-tomsk.ru` → `cardio`.
 *
 * Anti-enumeration: функция НЕ проверяет существование тенанта — только парсит хост, а попытка
 * входа на любой исход (нет тенанта / нет юзера / неверный пароль) отвечает единым
 * `invalid_credentials`. Подсказка сервера — осознанное исключение: она называет тенант только
 * для хоста, который суперадмин сам привязал к нему (и опубликовал в DNS); на любой другой хост
 * ответ одинаковый `null`, списка тенантов до входа нет.
 */

/** Базовый домен установки. Прод — omniflow.ru; переопределяется при сборке UI. */
const BASE_DOMAIN = (import.meta.env.VITE_BASE_DOMAIN ?? 'omniflow.ru').toLowerCase()

/** Служебные поддомены, которые НЕ являются тенантами (расширять здесь). */
const RESERVED_SUBDOMAINS = new Set(['www', 'app'])

export const getTenantFromHost = (): string | null => {
  const host = location.hostname.toLowerCase()
  const suffix = `.${BASE_DOMAIN}`
  if (!host.endsWith(suffix)) return null // localhost / IP / чужой домен / голый base
  const sub = host.slice(0, -suffix.length)
  if (!sub || sub.includes('.')) return null // голый base или многоуровневый поддомен
  if (RESERVED_SUBDOMAINS.has(sub)) return null
  return sub
}
